import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-politique',
  templateUrl: './politique.component.html',
  styleUrls: ['./politique.component.scss'],
})
export class PolitiqueComponent implements OnInit {

  constructor(private readonly router: Router) { }

  ngOnInit() {}

  backClick() {
    this.router.navigateByUrl("/coach/about");
  }

}
